import {
    Button,
    Card,
    CardContent,
    Divider,
    Grid,
    Tab,
    Tabs,
    Typography,
} from "@mui/material";
import { Box } from "@mui/system";
import { FunctionComponent, useState } from "react";
import { Inistitution } from "../institution";
import CloudDownloadIcon from '@mui/icons-material/CloudDownload';
import { HallTicketGeneration } from "./hallTicketGeneration";
import { ProgressCardGeneration } from "./progressCardGeneration";

interface TabPanelProps {
    children?: React.ReactNode;
    index: number;
    value: number;
}

function CustomTabPanel(props: TabPanelProps) {
    const { children, value, index, ...other } = props;

    return (
        <div
            role="tabpanel"
            hidden={value !== index}
            id={`simple-tabpanel-${index}`}
            aria-labelledby={`simple-tab-${index}`}
            {...other}
        >
            {value === index && <Box sx={{ p: 0 }}>{children}</Box>}
        </div>
    );
}

function a11yProps(index: number) {
    return {
        id: `simple-tab-${index}`,
        'aria-controls': `simple-tabpanel-${index}`,
    };
}
export const SchoolCertifications: FunctionComponent = () => {
    const [tabValue, setTabValue] = useState(0);

    const handleTabChange = (event: React.SyntheticEvent, newValue: number) => {
        setTabValue(newValue);
    };


    return (
        <Inistitution>
            <Grid container sx={{ height: "100%" }}>
                <Grid item xs={12}>
                    <Card sx={{ height: "100%" }}>
                        {/* Page header */}
                        <Box sx={{ px: 3, pt: 2.5, pb: 1.5, display: 'flex', alignItems: 'center', gap: 1.5 }}>
                            <Box sx={{ flexGrow: 1 }}>
                                <Typography variant="h6" sx={{ fontWeight: 700, lineHeight: 1.2 }}>
                                    Certifications
                                </Typography>
                                <Typography variant="body2" color="text.secondary" sx={{ mt: 0.25 }}>
                                    Hall Tickets &amp; Progress Cards
                                </Typography>
                            </Box>
                            <Button
                                variant="outlined"
                                size="small"
                                href={tabValue === 0
                                    ? 'https://oeeabhyas.blob.core.windows.net/public/oe/School-HallTicket-Sample.xlsx'
                                    : 'https://oeeabhyas.blob.core.windows.net/public/oe/school-progresscard-sample.xlsx'}
                                endIcon={<CloudDownloadIcon />}
                                target="_blank"
                            >
                                Download Template
                            </Button>
                        </Box>
                        <Divider />
                        <Box sx={{ borderBottom: 1, borderColor: 'divider', px: 3, bgcolor: 'grey.50' }}>
                            <Tabs
                                value={tabValue}
                                onChange={handleTabChange}
                                aria-label="certifications tabs"
                                variant="scrollable"
                                scrollButtons="auto"
                                sx={{
                                    minHeight: 48,
                                    '& .MuiTab-root': {
                                        textTransform: 'none',
                                        fontWeight: 500,
                                        fontSize: '0.875rem',
                                        minHeight: 48,
                                        px: 2.5,
                                        color: 'text.secondary',
                                        '&.Mui-selected': { fontWeight: 700, color: 'primary.main' },
                                    },
                                    '& .MuiTabs-indicator': { height: 3, borderRadius: '3px 3px 0 0' },
                                }}
                            >
                                <Tab label="Hall Tickets" {...a11yProps(0)} />
                                <Tab label="Progress Cards" {...a11yProps(1)} />
                            </Tabs>
                        </Box>
                        <CardContent sx={{ p: 0, '&:last-child': { pb: 0 } }}>
                            <CustomTabPanel value={tabValue} index={0}>
                                <HallTicketGeneration />
                            </CustomTabPanel>
                            <CustomTabPanel value={tabValue} index={1}>
                                <ProgressCardGeneration />
                            </CustomTabPanel>
                        </CardContent>
                    </Card>
                </Grid>
            </Grid>
        </Inistitution>
    );
};
